import React from "react";
import type { FunctionComponent } from "react";
import { observer } from "mobx-react-lite";
import Dropdown from "react-bootstrap/Dropdown";
import type EmailBlacklistsViewModel from "viewModels/administration/emailBlacklist/emailBlacklistsViewModel";
import type BlacklistedEmailAddress from "entities/blacklistedEmailAddress";

export interface EmailBlacklistActionMenuProps {
  vm: EmailBlacklistsViewModel;
  item: BlacklistedEmailAddress;
}

const EmailBlacklistActionMenu: FunctionComponent<EmailBlacklistActionMenuProps> = observer(
  (props: EmailBlacklistActionMenuProps) => {
    const { vm, item } = props;
    const onItemClick = vm.onItemClick();

    return (
      <Dropdown drop="left">
        <Dropdown.Toggle size="sm" variant="success" className="rounded caret-off">
          ⋮
        </Dropdown.Toggle>
        <Dropdown.Menu
          alignRight={true}
          popperConfig={{
            strategy: "fixed",
          }}>
          {vm.allowItemDetail(item) && onItemClick && (
            <Dropdown.Item onClick={() => onItemClick(item)}>{vm.translate("detail")}</Dropdown.Item>
          )}
          {vm.allowItemEdit(item) && <Dropdown.Item onClick={() => vm.onEditClick(item)}>{vm.translate("edit")}</Dropdown.Item>}
          {vm.allowItemDelete(item) && (
            <Dropdown.Item onClick={() => vm.onDeactivateClick(item)}>{vm.translate("deactivate")}</Dropdown.Item>
          )}
        </Dropdown.Menu>
      </Dropdown>
    );
  }
);

export default EmailBlacklistActionMenu;
